import {Component, OnInit} from '@angular/core';
import {CountryChartData} from '../../../../models/country-chart-data.interface';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {Master} from '../../../../../admin/models/master.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';
import {CountryChartInfo} from '../../../../models/country-chart-info.interface';

@Component({
  selector: 'app-trend-by-country-chart',
  templateUrl: './trend-by-country-chart.component.html',
  styleUrls: ['./trend-by-country-chart.component.scss']
})
export class TrendByCountryChartComponent implements OnInit {

  text = 'Total country values';
  subtitle = '';
  countries!: CountryChartInfo[];
  data!: [CountryChartData[]];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  categories!: Master[];
  countryCategory!: string;

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.router.url.includes('putonmarket')) {
      this.countryCategory = 'putonmarket';
      this.text = 'Trend in put on market - ' + this.text;
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    if (this.router.url.includes('collected')) {
      this.countryCategory = 'collected';
      this.text = 'Trend in collection - ' + this.text;
      this.kfChartsService.getCollectionStreams().subscribe(data => this.categories = data);
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', search.categoryType ? search.categoryType : 'NEW')
        .subscribe(availableYears => {
          this.years = availableYears;
          if (availableYears.length > 3) {
            if (!search.startYear) {
              search.startYear = availableYears[2];
            }
            this.subtitle = search.startYear + ' - ' + this.years[0] + (search.displayUnits === 'SPECIFIC' ? ' (kg/inh)' : ' (tons)');
          } else {
            this.subtitle = 'No data';
          }
          if (!search.categoryType) {
            search.categoryType = 'NEW';
          }
          if (!search.displayUnits) {
            search.displayUnits = 'ABSOLUTE';
          }
          this.kfChartsService.getTrendByCountryCountries(search, this.countryCategory).subscribe(
            response => this.countries = response
          );
          this.kfChartsService.getTrendByCountry(
            search, this.countryCategory).subscribe(response => {
            this.data = response;
          });
        });
    });

  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
    this.kfChartsService.getTrendByCountryCountries(event, this.countryCategory).subscribe(
      response => this.countries = response
    );
  }

  loadCategories(event: string): void {

    if (event === 'OLD') {
      this.kfChartsService.getOldPomCategories().subscribe(data => this.categories = data);
    } else {
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', event)
      .subscribe(data => this.years = data);
  }
}
